// src/utils/onboardingState.js
import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";

const SETTINGS_DOC_ID = "onboarding";

export async function getWelcomeSeen(db, companyId) {
  if (!db || !companyId) return false;
  const ref = doc(db, `companies/${companyId}/settings`, SETTINGS_DOC_ID);
  const snap = await getDoc(ref);
  return !!snap.data()?.welcomeSeen;
}

export async function setWelcomeSeen(db, companyId) {
  if (!db || !companyId) return;
  const ref = doc(db, `companies/${companyId}/settings`, SETTINGS_DOC_ID);
  await setDoc(
    ref,
    { welcomeSeen: true, welcomeSeenAt: serverTimestamp() },
    { merge: true }
  );
}

// ✅ Pilot tour "seen" flag (separate from regular welcome tour)
export async function getPilotTourSeen(db, companyId) {
  if (!companyId) return false;
  const ref = doc(db, "companies", companyId);
  const snap = await getDoc(ref);
  return !!snap.data()?.tourSeen?.pilot;
}

export async function setPilotTourSeen(db, companyId) {
  if (!companyId) return;
  const ref = doc(db, "companies", companyId);
  await updateDoc(ref, {
    "tourSeen.pilot": true,
  });
}
